export default "__VITE_ASSET__d80fb889__"